// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentPitch_container__2mS5O","treasureTrove":"ContentPitch_treasureTrove__1Gx5n","textContent":"ContentPitch_textContent__3O9dt","vault":"ContentPitch_vault__2Hhvw"};